var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('KDropdownMenu',{attrs:{"text":_vm.$tr('downloadContent'),"options":_vm.fileOptions},on:{"select":_vm.download}})}
var staticRenderFns = []

export { render, staticRenderFns }